// material-ui
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import WatchLaterTwoToneIcon from '@mui/icons-material/WatchLaterTwoTone'
import {
  Avatar,
  Badge,
  Box,
  Collapse,
  Grid,
  IconButton,
  List,
  ListItemButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import RQ from 'components/RedQuick'
import { mobileAndTabletCheck } from 'components/utility'
import * as enums from 'features/enumerations'
import * as firebaseapp from 'features/firebase-app'
import * as models from 'models'
import React from 'react'
import TitleService, { GetTimeSince } from 'title-service'
import SubCard from 'ui-component/cards/SubCard'

import { MediaStatus, ResourcePropertyType } from 'features/enumerations'

// assets

import { ProcessedMediaStatesProperties } from 'features/processedMediaStates/processedMediaStates-property-definitions'
import { ReleaseScheduleActionProperties } from 'features/releaseScheduleAction/releaseScheduleAction-property-definitions'
import { ProcessedMediaStates } from 'models'
// ================================|| UI LIST - SIMPLE LIST ||================================ //
export function decipherDate(value: any) {
  if (value && value.seconds) {
    value = new Date(value.seconds * 1000)
  } else if (value && value._seconds) {
    value = new Date(value._seconds * 1000)
  } else if (typeof value === 'number') {
    value = new Date(value)
  } else if (typeof value === 'string') {
    value = new Date(Date.parse(value))
  }
  return value
}
export function addDays(date2: Date, days: number) {
  let date = new Date(date2.valueOf())
  date.setDate(date.getDate() + days)
  return date
}
export const ListWrapper = styled('div')(({ theme }) => ({
  padding: '15px 0',
  borderBottom: theme.palette.mode === 'dark' ? 'none' : '1px solid',
  borderTop: theme.palette.mode === 'dark' ? 'none' : '1px solid',
  borderColor: `${theme.palette.grey[100]}!important`,
}))
export const ListItemWrapper = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  padding: 16,
  '&:hover': {
    background:
      theme.palette.mode === 'dark'
        ? theme.palette.dark.main
        : theme.palette.primary.light,
  },
  '& .MuiListItem-root': {
    padding: 0,
  },
}))
export function approvalRequestList(list: any, onclick: any, theme: any): any {
  return (
    <List
      sx={{
        maxHeight: `calc(100vh - 400px)`,
        overflowY: 'auto',
      }}
      component="nav"
      aria-label="main mailbox folders"
    >
      {(list || []).map((approvalRequest, index) => {
        let statusColor = approvalRequest.isApproving
          ? theme.palette.success.main
          : theme.palette.grey[500]
        let assignedPerson = null
        let statusTitle = TitleService(approvalRequest.status || '')
        if (approvalRequest.isApproving) {
          statusColor = theme.palette.primary.main
          assignedPerson = `${approvalRequest?.player?.firstName} ${approvalRequest?.player?.lastName}`
        } else if (approvalRequest.approvingWithDifferentPlayer) {
          statusColor = theme.palette.secondary.main
          assignedPerson = `${approvalRequest?.player?.firstName} ${approvalRequest?.player?.lastName}`
        }
        return (
          <ListItemButton
            key={index}
            selected={approvalRequest?.selected}
            onClick={() => {
              onclick(approvalRequest)
            }}
          >
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item>
                  <Box sx={{ position: 'relative' }}>
                    <Badge
                      overlap="circular"
                      badgeContent={
                        <FiberManualRecordIcon
                          sx={{
                            color: statusColor,
                            fontSize: '0.875rem',
                          }}
                        />
                      }
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                    >
                      <Avatar
                        alt={approvalRequest?.contentHouse?.name}
                        title={approvalRequest?.contentHouse?.name}
                        src={
                          approvalRequest?.contentHouse
                            ?.contentHouseProfileImage
                        }
                      />
                    </Badge>
                  </Box>
                </Grid>
                <Grid item xs zeroMinWidth>
                  <Typography align="left" component="div" variant="subtitle1">
                    {approvalRequest?.media?.name ||
                      approvalRequest?.series?.name}
                  </Typography>
                  <Typography
                    align="left"
                    component="div"
                    style={{
                      whiteSpace: 'nowrap',
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                    variant="subtitle2"
                  >
                    {statusTitle}
                  </Typography>
                </Grid>
                <Grid item>
                  <Stack
                    direction="row"
                    alignContent="flex-end"
                    alignItems="flex-end"
                    justifyContent="flex-end"
                  >
                    <Typography
                      align="right"
                      justifyContent="center"
                      component="div"
                      variant="subtitle1"
                    >
                      {assignedPerson}
                    </Typography>
                    <Typography
                      align="right"
                      justifyContent="center"
                      component="div"
                      sx={{ lineHeight: 1, paddingLeft: `4px` }}
                      variant="subtitle1"
                    >
                      {approvalRequest?.media ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-device-tv"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="#597e8d"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <rect x="3" y="7" width="18" height="13" rx="2" />
                          <polyline points="16 3 12 7 8 3" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-device-tv"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="#00bfd8"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <rect x="3" y="7" width="18" height="13" rx="2" />
                          <polyline points="16 3 12 7 8 3" />
                        </svg>
                      )}
                    </Typography>
                  </Stack>
                  <Typography align="right" variant="caption">
                    <WatchLaterTwoToneIcon
                      sx={{
                        fontSize: '0.875rem',
                        marginRight: 0.2,
                        verticalAlign: 'sub',
                      }}
                    />
                    {GetTimeSince(approvalRequest)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </ListItemButton>
        )
      })}
    </List>
  )
}
export function approveCheckSmall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-check"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="#00b341"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 12l5 5l10 -10" />
    </svg>
  )
}

export function displaySeasonList(list: any, media: any, theme: any): any {
  return (
    <>
      {(list || []).map((season) => {
        let seasonMedia = media.filter((v) => {
          return season?.media && season?.media?.find((g) => g.id === v.id)
        })
        return (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item>
                    <Box sx={{ position: 'relative' }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-playlist"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="#00b341"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <circle cx="14" cy="17" r="3" />
                        <path d="M17 17v-13h4" />
                        <path d="M13 5h-10" />
                        <line x1="3" y1="9" x2="13" y2="9" />
                        <path d="M9 13h-6" />
                      </svg>
                    </Box>
                  </Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography
                      align="left"
                      component="div"
                      variant="subtitle1"
                    >
                      {season?.name}
                    </Typography>
                    <Typography
                      align="left"
                      component="div"
                      style={{
                        whiteSpace: 'nowrap',
                        maxWidth: 200,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                      }}
                      variant="subtitle2"
                    >
                      {season?.description}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography align="left" variant="caption">
                      <WatchLaterTwoToneIcon
                        sx={{
                          fontSize: '0.875rem',
                          marginRight: 0.2,
                          verticalAlign: 'sub',
                        }}
                      />
                      {GetTimeSince(season)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={11}>
                <List component="nav" aria-label="main mailbox folders">
                  {seasonMedia.map((item) => {
                    return makeMediaListItem(item, null, theme)
                  })}
                </List>
              </Grid>
            </Grid>
          </>
        )
      })}
    </>
  )
}
export function resolveSizeUrl(
  states: ProcessedMediaStates[],
  resourcePropertyType: ResourcePropertyType,
  size: number,
  defaultValue: string,
): any {
  if (states && states.length) {
    let sorted = states
      .filter((x) => x.resourcePropertyType === resourcePropertyType)
      .sort((a: ProcessedMediaStates, b: ProcessedMediaStates) => {
        return Math.abs(a.width - size) - Math.abs(b.width - size)
      })
    if (
      sorted &&
      sorted[0] &&
      sorted[0][ProcessedMediaStatesProperties.MediaRel]
    ) {
      return sorted[0][ProcessedMediaStatesProperties.MediaRel]
    }
  }
  return defaultValue
} // <cut-off>
export function errorSign() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-alert-octagon"
      width="68"
      height="68"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="#ff2825"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  )
}
export function errorSignSmall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-alert-triangle"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="#ff2825"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 9v2m0 4v.01" />
      <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75" />
    </svg>
  )
}
export function SnapSeasonTable(
  episodes: any,
  snap: any,
  episodeRowBuilderFunc: any,
  onChange: any,
) {
  return (
    <TableContainer>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ pl: 3 }} />
            <TableCell>{TitleService('Episode')}</TableCell>
            <TableCell align="right">{TitleService('Release Date')}</TableCell>
            <TableCell align="right">{TitleService('Expiry Date')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {episodes.map((row) => episodeRowBuilderFunc(row.id, snap, onChange))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export function SnapMediaReleaseActionRow(props: {
  media: any
  snap: any
  onChange: any
}) {
  const theme = useTheme()
  const { media, snap } = props
  const { seriesId, seasonId } = snap || {}
  const mediaId = media?.id
  const [open, setOpen] = React.useState(false)
  let actions = snap?.actions || []
  let actionGroup = {}
  let releaseDate = null
  let expiryDate = null
  actions
    .filter(
      (x) =>
        x.mediaId === media?.id &&
        x.seriesId === seriesId &&
        x.seasonId === seasonId,
    )
    .map((action) => {
      actionGroup[action?.releaseZone?.id] =
        actionGroup[action?.releaseZone?.id] || {}
      switch (action.releaseActionType) {
        case enums.ReleaseActionType.ScheduledRelease:
          actionGroup[action?.releaseZone?.id].release = action
          if (action.releaseDate && action.enabled) {
            releaseDate = decipherDate(action.releaseDate)
          }
          break
        case enums.ReleaseActionType.ScheduledUnrelease:
          if (action.releaseDate && action.enabled) {
            expiryDate = decipherDate(action.releaseDate)
          }
          actionGroup[action?.releaseZone?.id].unrelease = action
          break
      }
    })
  return (
    <>
      <TableRow hover sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell sx={{ pl: 3 }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {media.name}
        </TableCell>
        <TableCell align="right" sx={{ pr: 3 }}>
          {releaseDate ? releaseDate.toDateString() : ''}
        </TableCell>
        <TableCell align="right" sx={{ pr: 3 }}>
          {expiryDate ? expiryDate.toDateString() : ''}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{
                margin: 1,
              }}
            >
              <TableContainer>
                <SubCard
                  sx={{
                    bgcolor:
                      theme.palette.mode === 'dark' ? 'dark.800' : 'grey.50',
                    mb: 2,
                  }}
                  title={TitleService('Release Action Schedule')}
                  content={false}
                >
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell>{TitleService('Enabled')}</TableCell>
                        <TableCell>{TitleService('Release Date')}</TableCell>
                        <TableCell>{TitleService('Enabled')}</TableCell>
                        <TableCell>{TitleService('Expiry Date')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.values(actionGroup)?.map(
                        (action: any, index: number) => {
                          return (
                            <TableRow hover key={`action-group-${index}`}>
                              <TableCell component="th" scope="row">
                                <RQ.RedQuickCheckBox
                                  value={action?.release?.enabled}
                                  onChange={() => {
                                    props.onChange({
                                      seriesId,
                                      seasonId,
                                      mediaId,
                                      id: action?.release?.id,
                                      prop: ReleaseScheduleActionProperties.Enabled,
                                      value: !action?.release?.enabled,
                                    })
                                    console.log('updated')
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <RQ.RedQuickDatePicker
                                  title={TitleService('Release Date')}
                                  disabled={
                                    !(action?.release?.enabled || false)
                                  }
                                  minDate={new Date(Date.now())}
                                  value={
                                    action?.release?.releaseDate || new Date()
                                  }
                                  onChange={(val) => {
                                    console.log('updated')
                                    props.onChange({
                                      seriesId,
                                      seasonId,
                                      mediaId,
                                      id: action?.release?.id,
                                      prop: ReleaseScheduleActionProperties.ReleaseDate,
                                      value: val,
                                    })
                                  }}
                                />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <RQ.RedQuickCheckBox
                                  value={action?.unrelease?.enabled || false}
                                  onChange={() => {
                                    console.log('updated')
                                    props.onChange({
                                      seriesId,
                                      seasonId,
                                      mediaId,
                                      id: action?.unrelease?.id,
                                      prop: ReleaseScheduleActionProperties.Enabled,
                                      value: !action?.unrelease?.enabled,
                                    })
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <RQ.RedQuickDatePicker
                                  title={TitleService('Expiry Date')}
                                  value={
                                    action?.unrelease?.releaseDate || new Date()
                                  }
                                  minDate={
                                    new Date(
                                      action?.release?.releaseDate ||
                                        new Date(),
                                    )
                                  }
                                  disabled={
                                    !(action?.unrelease?.enabled || false)
                                  }
                                  onChange={(val) => {
                                    console.log('updated')
                                    props.onChange({
                                      seriesId,
                                      seasonId,
                                      mediaId,
                                      id: action?.unrelease?.id,
                                      prop: ReleaseScheduleActionProperties.ReleaseDate,
                                      value: val,
                                    })
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          )
                        },
                      )}
                    </TableBody>
                  </Table>
                </SubCard>
              </TableContainer>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}

export function SnapMediaReleaseActionRowBuilder(
  mediaId: any,
  snap: any,
  onChange: any,
) {
  let media = snap.media.find((v) => v.id === mediaId)
  return (
    <SnapMediaReleaseActionRow
      key={mediaId}
      media={media}
      snap={snap}
      onChange={onChange}
    />
  )
}
export function mediaList(localMedias: any, onclick: any, theme: any): any {
  return (
    <List
      sx={{
        maxHeight: `calc(100vh - 400px)`,
        overflowY: 'auto',
      }}
      component="nav"
      aria-label="main mailbox folders"
    >
      {(localMedias || []).map((media, index) => {
        let statusColor = theme.palette.grey[500]
        let statusTitle = ''
        if (media?.mediaInformation) {
          if (media?.mediaInformation?.mediaStatus === MediaStatus.Unreviewed) {
            statusColor = theme.palette.info.main
            statusTitle = TitleService('Unreviewed')
          } else if (
            media?.mediaInformation?.mediaStatus === MediaStatus.Reviewed
          ) {
            statusColor = theme.palette.success.main
            statusTitle = TitleService('Reviewed')
          }
        }
        return (
          <ListItemButton
            key={index}
            onClick={() => {
              onclick(media)
            }}
          >
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item>
                  <Box sx={{ position: 'relative' }}>
                    <Badge
                      overlap="circular"
                      badgeContent={
                        <FiberManualRecordIcon
                          sx={{
                            color: statusColor,
                            fontSize: '0.875rem',
                          }}
                        />
                      }
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                    >
                      <Avatar
                        alt={media.name}
                        title={statusTitle}
                        src={media?.thumbnail}
                      />
                    </Badge>
                  </Box>
                </Grid>
                <Grid item xs zeroMinWidth>
                  <Typography align="left" component="div" variant="subtitle1">
                    {media?.description?.nameDefault}
                  </Typography>
                  <Typography
                    align="left"
                    component="div"
                    style={{
                      whiteSpace: 'nowrap',
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                    variant="subtitle2"
                  >
                    {media?.description?.descriptionDefault}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography align="left" variant="caption">
                    <WatchLaterTwoToneIcon
                      sx={{
                        fontSize: '0.875rem',
                        marginRight: 0.2,
                        verticalAlign: 'sub',
                      }}
                    />
                    {GetTimeSince(media)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </ListItemButton>
        )
      })}
    </List>
  )
}

export function makeMediaListItem(
  media: any,
  onDelete: any,
  theme: any,
  ops?: any,
) {
  let statusColor = theme.palette.grey[500]
  let statusTitle = ''
  if (media?.mediaInformation) {
    if (media?.mediaStatus === MediaStatus.Unreviewed) {
      statusColor = theme.palette.info.main
      statusTitle = TitleService('Unreviewed')
    } else if (media?.mediaStatus === MediaStatus.Reviewed) {
      statusColor = theme.palette.secondary.main
      statusTitle = TitleService('Reviewed')
    } else if (media?.mediaStatus === MediaStatus.RequestingApproval) {
      statusColor = theme.palette.primary.main
      statusTitle = TitleService('Requsting Review')
    } else if (media?.mediaStatus === MediaStatus.Approved) {
      statusColor = theme.palette.success.main
      statusTitle = TitleService('Approved')
    } else if (media?.mediaStatus === MediaStatus.Rejected) {
      statusColor = theme.palette.error.main
      statusTitle = TitleService('Rejected')
    }
  }
  return (
    <ListItemButton
      key={media?.id}
      onClick={() => {
        if (ops && ops.onClick) {
          ops.onClick()
        }
      }}
    >
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item>
            <Box sx={{ position: 'relative' }}>
              <Badge
                overlap="circular"
                badgeContent={
                  <FiberManualRecordIcon
                    sx={{
                      color: statusColor,
                      fontSize: '0.875rem',
                    }}
                  />
                }
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
              >
                <Avatar
                  alt={media?.name}
                  title={statusTitle}
                  src={media?.thumbnail}
                />
              </Badge>
            </Box>
          </Grid>
          <Grid item xs zeroMinWidth>
            <Typography align="left" component="div" variant="subtitle1">
              {media?.description?.nameDefault}
            </Typography>
            <Typography
              align="left"
              component="div"
              style={{
                whiteSpace: 'nowrap',
                maxWidth: 200,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
              variant="subtitle2"
            >
              {media?.description?.descriptionDefault}
            </Typography>
          </Grid>
          {onDelete && (
            <Grid
              item
              onClick={() => {
                if (onDelete) {
                  onDelete(media)
                }
              }}
            >
              <Typography align="left" variant="caption">
                <Typography align="left" variant="caption">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-trash-x"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#597e8d"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 7h16" />
                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                    <path d="M10 12l4 4m0 -4l-4 4" />
                  </svg>
                </Typography>
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </ListItemButton>
  )
}
export function seasonList(localSeasons: any, onclick: any): any {
  return (
    <List component="nav" aria-label="main mailbox folders">
      {(localSeasons || []).map((season, index) => {
        return (
          <ListItemButton
            key={index}
            selected={season?.selected}
            onClick={() => {
              onclick(season)
            }}
          >
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs zeroMinWidth>
                  <Typography align="left" component="div" variant="subtitle1">
                    {season?.name}
                  </Typography>
                  <Typography
                    align="left"
                    component="div"
                    style={{
                      whiteSpace: 'nowrap',
                      maxWidth: 200,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                    variant="subtitle2"
                  >
                    {season?.description}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography align="left" variant="caption">
                    <WatchLaterTwoToneIcon
                      sx={{
                        fontSize: '0.875rem',
                        marginRight: 0.2,
                        verticalAlign: 'sub',
                      }}
                    />
                    {GetTimeSince(season)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </ListItemButton>
        )
      })}
    </List>
  )
}

export function seasonListItem(season: any, ops: any): any {
  return (
    <ListItemButton
      key={season?.id}
      onClick={() => {
        if (ops && ops.onClick) {
          ops.onClick()
        }
      }}
    >
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs zeroMinWidth>
            <Typography align="left" component="div" variant="subtitle1">
              {TitleService(season?.name)}
            </Typography>
            <Typography
              align="left"
              component="div"
              style={{
                whiteSpace: 'nowrap',
                maxWidth: 200,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
              variant="subtitle2"
            >
              {TitleService(season?.description)}
            </Typography>
          </Grid>
          <Grid item>
            <Typography align="left" variant="caption">
              <WatchLaterTwoToneIcon
                sx={{
                  fontSize: '0.875rem',
                  marginRight: 0.2,
                  verticalAlign: 'sub',
                }}
              />
              {GetTimeSince(season)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </ListItemButton>
  )
}
export function resolveImgSrc(arg0: string, width: any) {
  let image = [30, 64, 128, 256, 512, 1024].sort((a, b) => {
    return Math.abs(a - width) - Math.abs(b - width)
  })
  if (arg0 === 'Beast' || arg0 === 'BeastWizard') {
    return `/profile-images/${arg0}.png_${image[0]}.png`
  }
  return `/profile-images/${arg0}_result.png_${image[0]}.png`
}

export function renderCuratedMediaListItem(
  item: any,
  theme: any,
  onDelete?: any,
): any {
  let statusColor = theme.palette.grey[500]
  return (
    <Grid item xs={12} key={item?.id}>
      <Grid container spacing={2}>
        <Grid item>
          <Box sx={{ position: 'relative' }}>
            <Badge
              overlap="circular"
              badgeContent={
                <FiberManualRecordIcon
                  sx={{
                    color: statusColor,
                    fontSize: '0.875rem',
                  }}
                />
              }
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-device-tv"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="#6f32be"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <rect x="3" y="7" width="18" height="13" rx="2" />
                <polyline points="16 3 12 7 8 3" />
              </svg>
            </Badge>
          </Box>
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography align="left" component="div" variant="subtitle1">
            {item?.name}
          </Typography>
          <Typography
            align="left"
            component="div"
            style={{
              whiteSpace: 'nowrap',
              maxWidth: 200,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
            variant="subtitle2"
          >
            {item?.description}
          </Typography>
        </Grid>
        <Grid
          item
          justifyContent="flex-end"
          alignContent="flex-end"
          justifyItems="flex-end"
          alignItems="flex-end"
        >
          <Stack
            direction="column"
            justifyContent="flex-end"
            alignContent="flex-end"
            justifyItems="flex-end"
            alignItems="flex-end"
          ></Stack>
        </Grid>
        {onDelete && (
          <Grid
            item
            style={{ cursor: 'pointer' }}
            onClick={() => {
              if (onDelete) {
                onDelete(item)
              }
            }}
          >
            <Typography align="left" variant="caption">
              <Typography align="left" variant="caption">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-trash-x"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="#597e8d"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 7h16" />
                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                  <path d="M10 12l4 4m0 -4l-4 4" />
                </svg>
              </Typography>
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}
export function CoherentScreenReleaseAction(props: {
  coherentScreen: any
  actions: any
  onChange: any
}) {
  const theme = useTheme()
  const { coherentScreen, actions } = props
  const coherentScreenId = coherentScreen?.id
  const [open, setOpen] = React.useState(false)
  let actionGroup = {}
  let releaseDate = null
  let expiryDate = null
  let possible = actions.filter(
    (x) => x.coherentScreenId === coherentScreen?.id,
  )
  if (!possible.length) {
    return <></>
  }
  possible.map((action) => {
    actionGroup[action?.releaseZone?.id] =
      actionGroup[action?.releaseZone?.id] || {}
    switch (action.releaseActionType) {
      case enums.ReleaseActionType.ScheduledRelease:
        actionGroup[action?.releaseZone?.id].release = action
        if (action.releaseDate && action.enabled) {
          releaseDate = new Date(action.releaseDate)
        }
        break
      case enums.ReleaseActionType.ScheduledUnrelease:
        if (action.releaseDate && action.enabled) {
          expiryDate = new Date(action.releaseDate)
        }
        actionGroup[action?.releaseZone?.id].unrelease = action
        break
    }
  })
  return (
    <div style={{ paddingTop: 10, paddingBottom: 10 }}>
      <TableContainer>
        <SubCard
          sx={{
            bgcolor: theme.palette.mode === 'dark' ? 'dark.800' : 'grey.50',
            mb: 2,
          }}
          title={TitleService('Release Action Schedule')}
          content={false}
        >
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                <TableCell>{TitleService('Enabled')}</TableCell>
                <TableCell>{TitleService('Release Date')}</TableCell>
                <TableCell>{TitleService('Enabled')}</TableCell>
                <TableCell>{TitleService('Expiry Date')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.values(actionGroup)?.map((action: any, index: number) => {
                return (
                  <TableRow hover key={`action-group-${index}`}>
                    <TableCell component="th" scope="row">
                      <RQ.RedQuickCheckBox
                        value={action?.release?.enabled}
                        onChange={() => {
                          props.onChange({
                            coherentScreenId,
                            releaseActionType:
                              enums.ReleaseActionType.ScheduledRelease,
                            id: action?.release?.id,
                            prop: ReleaseScheduleActionProperties.Enabled,
                            value: !action?.release?.enabled,
                          })
                          console.log('updated')
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <RQ.RedQuickDatePicker
                        title={TitleService('Release Date')}
                        disabled={!(action?.release?.enabled || false)}
                        minDate={new Date(Date.now())}
                        value={action?.release?.releaseDate || new Date()}
                        onChange={(val) => {
                          console.log('updated')
                          props.onChange({
                            coherentScreenId,
                            id: action?.release?.id,
                            releaseActionType:
                              enums.ReleaseActionType.ScheduledRelease,
                            prop: ReleaseScheduleActionProperties.ReleaseDate,
                            value: val,
                          })
                        }}
                      />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <RQ.RedQuickCheckBox
                        value={action?.unrelease?.enabled || false}
                        onChange={() => {
                          console.log('updated')
                          props.onChange({
                            coherentScreenId,
                            id: action?.unrelease?.id,
                            releaseActionType:
                              enums.ReleaseActionType.ScheduledUnrelease,
                            prop: ReleaseScheduleActionProperties.Enabled,
                            value: !action?.unrelease?.enabled,
                          })
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <RQ.RedQuickDatePicker
                        title={TitleService('Expiry Date')}
                        value={action?.unrelease?.releaseDate || new Date()}
                        minDate={
                          new Date(action?.release?.releaseDate || new Date())
                        }
                        disabled={!(action?.unrelease?.enabled || false)}
                        onChange={(val) => {
                          console.log('updated')
                          props.onChange({
                            coherentScreenId,
                            releaseActionType:
                              enums.ReleaseActionType.ScheduledUnrelease,
                            id: action?.unrelease?.id,
                            prop: ReleaseScheduleActionProperties.ReleaseDate,
                            value: val,
                          })
                        }}
                      />
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </SubCard>
      </TableContainer>
    </div>
  )
}
export function renderCuratedSeriesListItem(
  item: any,
  theme: any,
  onDelete?: any,
): any {
  let statusColor = theme.palette.grey[500]
  return (
    <Grid item xs={12} key={item?.id}>
      <Grid container spacing={2}>
        <Grid item>
          <Box sx={{ position: 'relative' }}>
            <Badge
              overlap="circular"
              badgeContent={
                <FiberManualRecordIcon
                  sx={{
                    color: statusColor,
                    fontSize: '0.875rem',
                  }}
                />
              }
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-device-tv"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="#fd0061"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <rect x="3" y="7" width="18" height="13" rx="2" />
                <polyline points="16 3 12 7 8 3" />
              </svg>
            </Badge>
          </Box>
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography align="left" component="div" variant="subtitle1">
            {item?.name}
          </Typography>
          <Typography
            align="left"
            component="div"
            style={{
              whiteSpace: 'nowrap',
              maxWidth: 200,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
            variant="subtitle2"
          >
            {item?.description}
          </Typography>
        </Grid>
        <Grid
          item
          justifyContent="flex-end"
          alignContent="flex-end"
          justifyItems="flex-end"
          alignItems="flex-end"
        >
          <Stack
            direction="column"
            justifyContent="flex-end"
            alignContent="flex-end"
            justifyItems="flex-end"
            alignItems="flex-end"
          ></Stack>
        </Grid>
        {onDelete && (
          <Grid
            item
            style={{ cursor: 'pointer' }}
            onClick={() => {
              if (onDelete) {
                onDelete(item)
              }
            }}
          >
            <Typography align="left" variant="caption">
              <Typography align="left" variant="caption">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-trash-x"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="#7e8d59"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 7h16" />
                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                  <path d="M10 12l4 4m0 -4l-4 4" />
                </svg>
              </Typography>
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}
export function CuratadMediaListMediaReleaseAction(props: {
  curatedMediaList: any
  actions: any
  onChange: any
}) {
  const theme = useTheme()
  const { curatedMediaList, actions } = props
  const curatedMediaListId = curatedMediaList?.id
  const [open, setOpen] = React.useState(false)
  let actionGroup = {}
  let releaseDate = null
  let expiryDate = null
  let potentialActions = actions.filter(
    (x) => x.curatedMediaListId === curatedMediaList?.id,
  )
  potentialActions.map((action) => {
    actionGroup[action?.releaseZone?.id] =
      actionGroup[action?.releaseZone?.id] || {}
    switch (action.releaseActionType) {
      case enums.ReleaseActionType.ScheduledRelease:
        actionGroup[action?.releaseZone?.id].release = action
        if (action.releaseDate && action.enabled) {
          releaseDate = new Date(action.releaseDate)
        }
        break
      case enums.ReleaseActionType.ScheduledUnrelease:
        if (action.releaseDate && action.enabled) {
          expiryDate = new Date(action.releaseDate)
        }
        actionGroup[action?.releaseZone?.id].unrelease = action
        break
    }
  })
  if (!potentialActions.length) {
    return <></>
  }
  return (
    <div style={{ paddingTop: 10, paddingBottom: 10 }}>
      <SubCard
        sx={{
          bgcolor: theme.palette.mode === 'dark' ? 'dark.800' : 'grey.50',
          mb: 2,
        }}
        title={TitleService('Release Action Schedule')}
        content={false}
      >
        <Table size="small" aria-label="purchases">
          <TableHead>
            <TableRow>
              <TableCell>{TitleService('Enabled')}</TableCell>
              <TableCell>{TitleService('Release Date')}</TableCell>
              <TableCell>{TitleService('Enabled')}</TableCell>
              <TableCell>{TitleService('Expiry Date')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.values(actionGroup)?.map((action: any, index: number) => {
              return (
                <TableRow hover key={`action-group-${index}`}>
                  <TableCell component="th" scope="row">
                    <RQ.RedQuickCheckBox
                      value={action?.release?.enabled}
                      onChange={() => {
                        props.onChange({
                          curatedMediaListId,
                          id: action?.release?.id,
                          releaseActionType:
                            enums.ReleaseActionType.ScheduledRelease,
                          prop: ReleaseScheduleActionProperties.Enabled,
                          value: !action?.release?.enabled,
                        })
                        console.log('updated')
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <RQ.RedQuickDatePicker
                      title={TitleService('Release Date')}
                      disabled={!(action?.release?.enabled || false)}
                      minDate={new Date(Date.now())}
                      value={action?.release?.releaseDate || new Date()}
                      onChange={(val) => {
                        console.log('updated')
                        props.onChange({
                          curatedMediaListId,
                          id: action?.release?.id,
                          releaseActionType:
                            enums.ReleaseActionType.ScheduledRelease,
                          prop: ReleaseScheduleActionProperties.ReleaseDate,
                          value: val,
                        })
                      }}
                    />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <RQ.RedQuickCheckBox
                      value={action?.unrelease?.enabled || false}
                      onChange={() => {
                        console.log('updated')
                        props.onChange({
                          curatedMediaListId,
                          id: action?.unrelease?.id,
                          releaseActionType:
                            enums.ReleaseActionType.ScheduledUnrelease,
                          prop: ReleaseScheduleActionProperties.Enabled,
                          value: !action?.unrelease?.enabled,
                        })
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <RQ.RedQuickDatePicker
                      title={TitleService('Expiry Date')}
                      value={action?.unrelease?.releaseDate || new Date()}
                      minDate={
                        new Date(action?.release?.releaseDate || new Date())
                      }
                      disabled={!(action?.unrelease?.enabled || false)}
                      onChange={(val) => {
                        console.log('updated')
                        props.onChange({
                          curatedMediaListId,
                          releaseActionType:
                            enums.ReleaseActionType.ScheduledUnrelease,
                          id: action?.unrelease?.id,
                          prop: ReleaseScheduleActionProperties.ReleaseDate,
                          value: val,
                        })
                      }}
                    />
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </SubCard>
    </div>
  )
}
export function renderMediaItem(item: any, theme: any, onDelete?: any): any {
  let statusColor = theme.palette.grey[500]
  let statusTitle = ''
  let isRejected = false
  let isApproved = false
  if (item) {
    if (item?.mediaStatus === MediaStatus.Unreviewed) {
      statusColor = theme.palette.info.main
      statusTitle = TitleService('Unreviewed')
    } else if (item?.mediaStatus === MediaStatus.Reviewed) {
      statusColor = theme.palette.success.main
      statusTitle = TitleService('Reviewed')
    }
    isApproved = item?.mediaStatus === MediaStatus.Approved
    isRejected = item?.mediaStatus === MediaStatus.Rejected
  }
  return (
    <Grid item xs={12} key={item?.id}>
      <Grid container spacing={2}>
        <Grid item>
          <Box sx={{ position: 'relative' }}>
            <Badge
              overlap="circular"
              badgeContent={
                <FiberManualRecordIcon
                  sx={{
                    color: statusColor,
                    fontSize: '0.875rem',
                  }}
                />
              }
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              <Avatar
                alt={item?.name}
                title={statusTitle}
                src={item?.thumbnail}
              />
            </Badge>
          </Box>
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography align="left" component="div" variant="subtitle1">
            {item?.name}
          </Typography>
        </Grid>
        <Grid
          item
          justifyContent="flex-end"
          alignContent="flex-end"
          justifyItems="flex-end"
          alignItems="flex-end"
        >
          <Stack
            direction="column"
            justifyContent="flex-end"
            alignContent="flex-end"
            justifyItems="flex-end"
            alignItems="flex-end"
          >
            {isApproved && approveCheckSmall()}
            {isRejected && errorSignSmall()}
            {!isRejected && (
              <Typography align="left" variant="caption">
                <WatchLaterTwoToneIcon
                  sx={{
                    fontSize: '0.875rem',
                    marginRight: 0.2,
                    verticalAlign: 'sub',
                  }}
                />
                {GetTimeSince(item)}
              </Typography>
            )}
          </Stack>
        </Grid>
        {onDelete && (
          <Grid
            sx={{ cursor: 'pointer' }}
            item
            onClick={() => {
              if (onDelete) {
                onDelete(item)
              }
            }}
          >
            <Typography
              sx={{ cursor: 'pointer' }}
              align="left"
              variant="caption"
            >
              <Typography align="left" variant="caption">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-trash-x"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="#597e8d"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 7h16" />
                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                  <path d="M10 12l4 4m0 -4l-4 4" />
                </svg>
              </Typography>
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export function renderSeriesItem(item: any, theme: any, onDelete?: any): any {
  let thumbnail = item?.titleMediaImageUrl
  let statusColor = theme.palette.grey[500]
  let statusTitle = ''
  let isRejected = false
  let isApproved = false
  if (item) {
    if (item?.mediaStatus === MediaStatus.Unreviewed) {
      statusColor = theme.palette.info.main
      statusTitle = TitleService('Unreviewed')
    } else if (item?.mediaStatus === MediaStatus.Reviewed) {
      statusColor = theme.palette.success.main
      statusTitle = TitleService('Reviewed')
    }
    isApproved = item?.mediaStatus === MediaStatus.Approved
    isRejected = item?.mediaStatus === MediaStatus.Rejected
  }
  return (
    <Grid item xs={12} key={item?.id}>
      <Grid container spacing={2}>
        <Grid item>
          <Box sx={{ position: 'relative' }}>
            <Badge
              overlap="circular"
              badgeContent={
                <FiberManualRecordIcon
                  sx={{
                    color: statusColor,
                    fontSize: '0.875rem',
                  }}
                />
              }
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              <Avatar alt={item?.name} title={statusTitle} src={thumbnail} />
            </Badge>
          </Box>
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography align="left" component="div" variant="subtitle1">
            {item?.name}
          </Typography>
          <Typography
            align="left"
            component="div"
            style={{
              whiteSpace: 'nowrap',
              maxWidth: 200,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
            variant="subtitle2"
          >
            {item?.description}
          </Typography>
        </Grid>
        <Grid
          item
          justifyContent="flex-end"
          alignContent="flex-end"
          justifyItems="flex-end"
          alignItems="flex-end"
        >
          <Stack
            direction="column"
            justifyContent="flex-end"
            alignContent="flex-end"
            justifyItems="flex-end"
            alignItems="flex-end"
          >
            {isApproved && approveCheckSmall()}
            {isRejected && errorSignSmall()}
            {!isRejected && (
              <Typography align="left" variant="caption">
                <WatchLaterTwoToneIcon
                  sx={{
                    fontSize: '0.875rem',
                    marginRight: 0.2,
                    verticalAlign: 'sub',
                  }}
                />
                {GetTimeSince(item)}
              </Typography>
            )}
          </Stack>
        </Grid>
        {onDelete && (
          <Grid
            sx={{ cursor: 'pointer' }}
            item
            onClick={() => {
              if (onDelete) {
                onDelete(item)
              }
            }}
          >
            <Typography align="left" variant="caption">
              <Typography align="left" variant="caption">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-trash-x"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="#597e8d"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 7h16" />
                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                  <path d="M10 12l4 4m0 -4l-4 4" />
                </svg>
              </Typography>
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}
export function CuratadSeriesListMediaReleaseAction(props: {
  curatedSeriesList: any
  actions: any
  onChange: any
}) {
  const theme = useTheme()
  const { curatedSeriesList, actions } = props
  const curatedSeriesListId = curatedSeriesList?.id
  const [open, setOpen] = React.useState(false)
  let actionGroup = {}
  let releaseDate = null
  let expiryDate = null
  let possible = actions.filter(
    (x) => x.curatedSeriesListId === curatedSeriesList?.id,
  )
  if (!possible.length) {
    return <></>
  }
  possible.map((action) => {
    actionGroup[action?.releaseZone?.id] =
      actionGroup[action?.releaseZone?.id] || {}
    switch (action.releaseActionType) {
      case enums.ReleaseActionType.ScheduledRelease:
        actionGroup[action?.releaseZone?.id].release = action
        if (action.releaseDate && action.enabled) {
          releaseDate = new Date(action.releaseDate)
        }
        break
      case enums.ReleaseActionType.ScheduledUnrelease:
        if (action.releaseDate && action.enabled) {
          expiryDate = new Date(action.releaseDate)
        }
        actionGroup[action?.releaseZone?.id].unrelease = action
        break
    }
  })
  return (
    <div style={{ paddingTop: 10, paddingBottom: 10 }}>
      <TableContainer>
        <SubCard
          sx={{
            bgcolor: theme.palette.mode === 'dark' ? 'dark.800' : 'grey.50',
            mb: 2,
          }}
          title={TitleService('Release Action Schedule')}
          content={false}
        >
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                <TableCell>{TitleService('Enabled')}</TableCell>
                <TableCell>{TitleService('Release Date')}</TableCell>
                <TableCell>{TitleService('Enabled')}</TableCell>
                <TableCell>{TitleService('Expiry Date')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.values(actionGroup)?.map((action: any, index: number) => {
                return (
                  <TableRow hover key={`action-group-${index}`}>
                    <TableCell component="th" scope="row">
                      <RQ.RedQuickCheckBox
                        value={action?.release?.enabled}
                        onChange={() => {
                          props.onChange({
                            curatedSeriesListId,
                            releaseActionType:
                              enums.ReleaseActionType.ScheduledRelease,
                            id: action?.release?.id,
                            prop: ReleaseScheduleActionProperties.Enabled,
                            value: !action?.release?.enabled,
                          })
                          console.log('updated')
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <RQ.RedQuickDatePicker
                        title={TitleService('Release Date')}
                        disabled={!(action?.release?.enabled || false)}
                        minDate={new Date(Date.now())}
                        value={action?.release?.releaseDate || new Date()}
                        onChange={(val) => {
                          console.log('updated')
                          props.onChange({
                            curatedSeriesListId,
                            id: action?.release?.id,
                            releaseActionType:
                              enums.ReleaseActionType.ScheduledRelease,
                            prop: ReleaseScheduleActionProperties.ReleaseDate,
                            value: val,
                          })
                        }}
                      />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <RQ.RedQuickCheckBox
                        value={action?.unrelease?.enabled || false}
                        onChange={() => {
                          console.log('updated')
                          props.onChange({
                            curatedSeriesListId,
                            id: action?.unrelease?.id,
                            releaseActionType:
                              enums.ReleaseActionType.ScheduledUnrelease,
                            prop: ReleaseScheduleActionProperties.Enabled,
                            value: !action?.unrelease?.enabled,
                          })
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <RQ.RedQuickDatePicker
                        title={TitleService('Expiry Date')}
                        value={action?.unrelease?.releaseDate || new Date()}
                        minDate={
                          new Date(action?.release?.releaseDate || new Date())
                        }
                        disabled={!(action?.unrelease?.enabled || false)}
                        onChange={(val) => {
                          console.log('updated')
                          props.onChange({
                            curatedSeriesListId,
                            releaseActionType:
                              enums.ReleaseActionType.ScheduledUnrelease,
                            id: action?.unrelease?.id,
                            prop: ReleaseScheduleActionProperties.ReleaseDate,
                            value: val,
                          })
                        }}
                      />
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </SubCard>
      </TableContainer>
    </div>
  )
}
export function sharedList(
  list: any,
  listItemBuilder: any,
  dataSelector: any,
  onclick: any,
): any {
  return (
    <List
      sx={{
        maxHeight: '50vh',
        overflow: 'auto',
      }}
      component="nav"
      aria-label="main mailbox folders"
    >
      {(list || []).map((item, index) => {
        return (
          <ListItemButton
            key={index}
            selected={item?.selected}
            onClick={() => {
              onclick(item)
            }}
          >
            {listItemBuilder(dataSelector(item))}
          </ListItemButton>
        )
      })}
    </List>
  )
}

export function sharedListItemBuilder(setup: any): any {
  let icon = setup?.getIcon()
  let name = setup?.name
  let statusColor = setup?.statusColor
  let description = setup?.description || ''
  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item>
          <Box sx={{ position: 'relative' }}>
            <Badge
              overlap="circular"
              badgeContent={
                <FiberManualRecordIcon
                  sx={{
                    color: statusColor,
                    fontSize: '0.875rem',
                  }}
                />
              }
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              {icon}
            </Badge>
          </Box>
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography align="left" component="div" variant="subtitle1">
            {name}
          </Typography>
          <Typography
            align="left"
            component="div"
            style={{
              whiteSpace: 'nowrap',
              maxWidth: 200,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
            variant="subtitle2"
          >
            {description}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}
export function getSrc(
  location: string,
  url: string,
  size: number,
  approvedSeries_list: any[],
  approvedMedia_list: any[],
  setUrlUpdated: () => void,
) {
  let states: models.ProcessedMediaStates[] = []
  approvedSeries_list.find((approved_series) => {
    if (approved_series?.processedSeries?.states) {
      states.push(
        ...approved_series?.processedSeries?.states?.filter((st) => {
          let found = st.sourceLocation === location
          return found
        }),
      )
    }
  })
  if (!states.length) {
    approvedMedia_list.find((approved_media) => {
      if (approved_media?.processedMedia?.states) {
        states.push(
          ...approved_media?.processedMedia?.states?.filter((st) => {
            let found = st.sourceLocation === location
            return found
          }),
        )
      }
    })
  }
  if (states.length) {
    states = states.sort((a, b) => {
      return Math.abs(a.width - size) - Math.abs(b.width - size)
    })
    let state = states[0]
    let cached_url = firebaseapp.GetCachedUrls(state.location)
    if (!cached_url) {
      firebaseapp.ResolveStorageUrl(state.location).then((res) => {
        if (res) {
          setUrlUpdated()
        }
      })
    } else {
      return cached_url
    }
    if (mobileAndTabletCheck()) {
      return null
    }
  }
  return url
}
